import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Divider, Stack, Typography } from '@mui/material';
import { Link } from '@/components/shared/link';
import { ApprovalDot } from './ApprovalDots';
import { toneColors } from './constants';
import { TextDetailsTuple } from '../text/textDetailsTuple';
export const ApprovalDetailsTooltip = t0 => {
  const $ = _c(13);
  const {
    awaitingApprovalCount,
    readyToApproveCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      bgcolor: "background.primary",
      borderRadius: "4px",
      boxShadow: 10
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography variant="subtitle2" color="text.secondary" sx={{
      paddingX: "24px"
    }}>You have requests that need your attention</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== awaitingApprovalCount) {
    t3 = !!awaitingApprovalCount && <ApprovalRow title="Awaiting approval" description="Submitted requests waiting for your review" count={awaitingApprovalCount} color={toneColors.pending.fg} />;
    $[2] = awaitingApprovalCount;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== readyToApproveCount) {
    t4 = !!readyToApproveCount && <ApprovalRow title="Ready to apply" description="Your approved requests waiting for action" count={readyToApproveCount} color={toneColors.apply.fg} />;
    $[4] = readyToApproveCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Stack>{t3}{t4}</Stack>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button href="/action-approvals" LinkComponent={Link} sx={{
      width: "max-content",
      alignSelf: "center"
    }} variant="text" color="primary">View All Action Requests</Button>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5) {
    t8 = <Stack className="dark" width="395px" paddingY="24px" gap="12px" sx={t1}>{t2}{t5}{t6}{t7}</Stack>;
    $[11] = t5;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
const ApprovalRow = t0 => {
  const $ = _c(14);
  const {
    title,
    description,
    count,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <ApprovalDot color={color} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description || $[3] !== title) {
    t2 = <TextDetailsTuple primaryProp={title} secondaryProp={description} />;
    $[2] = description;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Stack direction="row" alignItems="center" gap="12px" minWidth={0}>{t1}{t2}</Stack>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mr: "12px"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== count) {
    t5 = <Badge badgeContent={count} color="primary" sx={t4} />;
    $[9] = count;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <Stack paddingX="24px" paddingY="12px" direction="row" justifyContent="space-between" alignItems="center">{t3}{t5}</Stack>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};